import request from './request';

export const listAgents = () => request.get('/api/v1/agents/list/');

export const getAgentDetail = (agentId) =>
  request.get(`/api/v1/agents/${agentId}/`);

export const sendAgentMessage = (agentId, message, document = null, modelId = null) =>
  request.post(`/api/v1/agents/${agentId}/message/`, {
    message,
    document,
    ...(modelId && { model_id: modelId }),
  });

export const confirmAgent = (agentId) =>
  request.post(`/api/v1/agents/${agentId}/confirm/`);

export const createAgent = (payload) =>
  request.post('/api/v1/agents/', payload);

export const fetchAgentModels = () => request.get('/api/v1/agents/models/');

export const fetchAgentModes = () => request.get('/api/v1/agents/modes/');

export const updateAgentSettings = (agentId, payload) =>
  request.patch(`/api/v1/agents/${agentId}/settings/`, payload);

export const setMessageFeedback = (agentId, messageId, feedback) =>
  request.patch(`/api/v1/agents/${agentId}/messages/${messageId}/feedback/`, { feedback });

export const deleteAgent = (agentId) =>
  request.delete(`/api/v1/agents/${agentId}/`);

export const deleteAllAgents = () =>
  request.delete('/api/v1/agents/list/');
